import { useState } from 'react';

const reviews = [
  {
    id: 1,
    name: 'Carlos Martínez',
    rating: 5,
    date: 'Hace 2 meses',
    text: 'Increíble trabajo de Daro. Me hizo un retrato realista en el brazo y el nivel de detalle es impresionante. Muy profesional, limpio y atento durante todo el proceso. Sin duda el mejor tatuador de la zona.',
    avatar: 'CM'
  },
  {
    id: 2,
    name: 'Laura Sánchez',
    rating: 5,
    date: 'Hace 1 mes',
    text: 'Llevo años buscando un tatuador especializado en Black & Grey y finalmente encontré a Daro. El resultado superó todas mis expectativas. Totalmente recomendable, volveré seguro para mi próximo tatuaje.',
    avatar: 'LS'
  },
  {
    id: 3,
    name: 'Miguel Ángel Torres',
    rating: 5,
    date: 'Hace 3 semanas',
    text: 'Excelente experiencia de principio a fin. Daro es un artista de verdad, me asesoró perfectamente sobre el diseño y la ubicación. El estudio es muy limpio y profesional. 100% recomendado.',
    avatar: 'MT'
  },
  {
    id: 4,
    name: 'Ana Rodríguez',
    rating: 5,
    date: 'Hace 1 semana',
    text: 'Me hizo un cover-up espectacular. Transformó un tatuaje viejo que no me gustaba en una obra de arte. Su técnica en sombreados es excepcional. Muy contenta con el resultado final.',
    avatar: 'AR'
  },
  {
    id: 5,
    name: 'Javier Moreno',
    rating: 5,
    date: 'Hace 2 semanas',
    text: 'Profesionalidad al 100%. Daro se tomó el tiempo de entender exactamente lo que quería y el resultado es perfecto. El proceso fue cómodo y el precio muy justo para la calidad que ofrece.',
    avatar: 'JM'
  },
  {
    id: 6,
    name: 'Patricia Gómez',
    rating: 5,
    date: 'Hace 1 mes',
    text: 'Mi primer tatuaje y no pude elegir mejor. Daro me explicó todo el proceso, fue muy paciente y el resultado es hermoso. El estudio es impecable y se nota la experiencia. Totalmente satisfecha.',
    avatar: 'PG'
  }
];

export default function ReviewsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextReview = () => {
    setCurrentIndex((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  const goToReview = (index: number) => {
    setCurrentIndex(index);
  };

  const averageRating = 5.0;
  const totalReviews = reviews.length;

  return (
    <section id="resenas" className="py-16 md:py-32 bg-neutral-850 relative" style={{ backgroundColor: '#1a1a1a' }}>
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")'
      }}></div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        <div className="text-center mb-10 md:mb-16">
          <h2 
            className="text-[50px] sm:text-[70px] md:text-[90px] leading-none font-bold text-white mb-4 md:mb-6"
            style={{ 
              fontFamily: 'Bebas Neue, sans-serif',
              letterSpacing: '8px'
            }}
          >
            OPINIONES REALES
          </h2>
          
          <div className="flex items-center justify-center gap-3 md:gap-4 mb-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-xl md:text-3xl text-amber-500"></i>
              ))}
            </div>
            <span className="text-2xl md:text-4xl font-bold text-white">{averageRating}</span>
          </div>
          
          <p className="text-neutral-400 text-sm md:text-lg">
            Basado en <strong className="text-white">{totalReviews} reseñas verificadas</strong> de clientes reales
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-neutral-800 p-6 md:p-12 relative overflow-hidden border border-neutral-700">
            <div className="absolute top-0 left-0 w-2 h-full bg-amber-500"></div>

            <div className="flex items-start gap-4 md:gap-6 mb-4 md:mb-6">
              <div 
                className="w-12 h-12 md:w-16 md:h-16 bg-neutral-700 text-white flex items-center justify-center text-base md:text-xl font-bold flex-shrink-0"
                style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%)' }}
              >
                {reviews[currentIndex].avatar}
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-2 gap-1">
                  <h3 className="text-xl md:text-2xl font-bold text-white" style={{ fontFamily: 'Bebas Neue, sans-serif' }}>
                    {reviews[currentIndex].name}
                  </h3>
                  <span className="text-xs md:text-sm text-neutral-500">{reviews[currentIndex].date}</span>
                </div>
                
                <div className="flex gap-1 mb-2 md:mb-4">
                  {[...Array(reviews[currentIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-base md:text-xl text-amber-500"></i>
                  ))}
                </div>
              </div>
            </div>

            <p className="text-neutral-300 text-sm md:text-lg leading-relaxed mb-6 md:mb-8 pl-0 md:pl-22">
              &quot;{reviews[currentIndex].text}&quot;
            </p>

            <div className="flex items-center justify-between pl-0 md:pl-22">
              <div className="flex gap-1.5 md:gap-2 flex-wrap">
                {reviews.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => goToReview(index)}
                    className={`h-2 md:h-3 transition-all cursor-pointer ${
                      index === currentIndex 
                        ? 'bg-amber-500 w-6 md:w-8' 
                        : 'bg-neutral-600 hover:bg-neutral-500 w-2 md:w-3'
                    }`}
                    aria-label={`Ir a reseña ${index + 1}`}
                  ></button>
                ))}
              </div>

              <div className="flex gap-2 md:gap-3">
                <button
                  onClick={prevReview}
                  className="w-10 h-10 md:w-12 md:h-12 bg-neutral-700 text-white flex items-center justify-center hover:bg-neutral-600 transition-colors cursor-pointer"
                  style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%)' }}
                  aria-label="Reseña anterior"
                >
                  <i className="ri-arrow-left-line text-lg md:text-xl"></i>
                </button>
                <button
                  onClick={nextReview}
                  className="w-10 h-10 md:w-12 md:h-12 bg-neutral-700 text-white flex items-center justify-center hover:bg-neutral-600 transition-colors cursor-pointer"
                  style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 8px), calc(100% - 8px) 100%, 0 100%)' }}
                  aria-label="Siguiente reseña"
                >
                  <i className="ri-arrow-right-line text-lg md:text-xl"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="mt-8 md:mt-12 text-center">
            <a
              href="https://share.google/3bjsbLu3mbFOBIVoB"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-8 py-4 bg-neutral-800 border-2 border-neutral-600 text-white font-bold hover:bg-neutral-700 hover:border-neutral-500 transition-all cursor-pointer whitespace-nowrap"
              style={{ clipPath: 'polygon(0 0, 100% 0, 100% calc(100% - 12px), calc(100% - 12px) 100%, 0 100%)' }}
            >
              <i className="ri-google-fill text-2xl"></i>
              VER TODAS LAS RESEÑAS EN GOOGLE
              <i className="ri-external-link-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
